export default __webpack_public_path__ + "static/media/8.95872116.jpg";